// extracted by mini-css-extract-plugin
export default {"artifacts":"ArtifactItems_artifacts__maICA","notFound":"ArtifactItems_notFound__jSd1e"};